import { render, staticRenderFns } from "./InvestmentPlan.vue?vue&type=template&id=2044c47e&scoped=true&"
import script from "./InvestmentPlan.vue?vue&type=script&lang=js&"
export * from "./InvestmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentPlan.vue?vue&type=style&index=0&id=2044c47e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044c47e",
  null
  
)

export default component.exports